/**
 * Merges the base theme with the accent (sidenav) color from settings.
 * Use this so borders, buttons (primary), and inputs follow the theme color.
 */

import { createTheme } from "@mui/material/styles";

const SIDENAV_COLORS = ["primary", "dark", "info", "success", "warning", "error"];

export default function getThemeWithAccent(baseTheme, sidenavColor = "info") {
  const colorKey = SIDENAV_COLORS.includes(sidenavColor) ? sidenavColor : "info";
  const accent = baseTheme.palette[colorKey] || baseTheme.palette.primary;
  const accentGradient = baseTheme.palette.gradients?.[colorKey] || baseTheme.palette.gradients?.primary;
  const rgba = baseTheme.functions?.rgba;

  const borderColorValue = rgba ? rgba(accent.main, 0.4) : accent.main;
  const inputBorderColorValue = rgba ? rgba(accent.main, 0.5) : accent.main;

  return createTheme(baseTheme, {
    palette: {
      primary: accent,
      info: accent,
      gradients: {
        ...baseTheme.palette.gradients,
        primary: accentGradient,
        info: accentGradient,
      },
      inputBorderColor: inputBorderColorValue,
    },
    borders: {
      ...baseTheme.borders,
      borderColor: borderColorValue,
    },
  });
}
